import { useCallback } from 'react';

import { useRachelStore } from '../store/rachel.store';
import { selectSetIsRachelCompacting } from '../store/rachel.store.selectors';
import type { RachelCompactingPayload } from './rachelCompacting.schema';

export const useRachelCompactingHandler = () => {
  const setIsCompacting = useRachelStore(selectSetIsRachelCompacting);

  return useCallback(
    (payload: RachelCompactingPayload) => {
      setIsCompacting(payload.phase === 'start');
    },
    [setIsCompacting],
  );
};
